"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ACTIVE_UNIT_ID = 'activeUnitId';
var ACTIVE_ORG_HIERARCHY_ID = 'activeOrgHierarchyId';
var OrgHierarchyFilterHelper = /** @class */ (function () {
    function OrgHierarchyFilterHelper(_env) {
        this.env = _env;
    }
    /**
     * Checks whether multiselect orgH is enabled
     * @return {boolean} Whether the multiselect OrgH feature flipper is on
     */
    OrgHierarchyFilterHelper.prototype.isMultiSelectOrgHEnabled = function () {
        return true;
    };
    /**
     * Gets the unit Id(s) that are currently active in the filter
     * @return {string | string[]} The active unit Id(s) that are stored on the env variable
     */
    OrgHierarchyFilterHelper.prototype.getActiveUnitId = function () {
        var activeUnitId = this.env.get(ACTIVE_UNIT_ID);
        if (activeUnitId !== undefined) {
            this._throwErrorIfInvalidActiveUnitId(activeUnitId);
        }
        return activeUnitId;
    };
    /**
     * Gets the org hierarchy Id(s) that are currently active in the filter
     * @return {string} The active org hierarchy Id stored on the env variable
     */
    OrgHierarchyFilterHelper.prototype.getActiveOrgHierarchyId = function () {
        return this.env.get(ACTIVE_ORG_HIERARCHY_ID);
    };
    /**
     * Sets the unit Id(s) that are currently active in the filter
     * @param {string | string[]} activeUnitId? The new activeUnitId value
     */
    OrgHierarchyFilterHelper.prototype.setActiveUnitId = function (activeUnitId) {
        if (activeUnitId !== undefined) {
            this._throwErrorIfInvalidActiveUnitId(activeUnitId);
        }
        this.env.set(ACTIVE_UNIT_ID, activeUnitId);
    };
    /**
     * Sets the org hierarchy Id(s) that are currently active in the filter
     * @param {string | string[]} activeOrgHierarchyId? The new activeOrgHierarchyId value
     */
    OrgHierarchyFilterHelper.prototype.setActiveOrgHierarchyId = function (activeOrgHierarchyId) {
        this.env.set(ACTIVE_ORG_HIERARCHY_ID, activeOrgHierarchyId);
    };
    /**
     * Checks the type of the activeUnitId passed in. Will throw an error if the activeUnitId is an invalid type, and
     * will do nothing otherwise.
     * @private
     * @param {string | string[]} activeUnitId An activeUnitId value
     */
    OrgHierarchyFilterHelper.prototype._throwErrorIfInvalidActiveUnitId = function (activeUnitId) {
        if (!Array.isArray(activeUnitId)) {
            throw new Error('MultiSelect OrgH is on: env.activeUnitId should be a list');
        }
    };
    return OrgHierarchyFilterHelper;
}());
exports.default = OrgHierarchyFilterHelper;
//# sourceMappingURL=org-hierarchy-filter-helper.js.map